import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {NewsletterService} from '../services/newsletter.service';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {NewsletterFormContent} from '../models/tenant.model';
import {selectNewsletterContent, selectTenantInfo} from '../store/selectors';
import {map} from 'rxjs/operators';
import {MessagesService} from '../shared/services/messages.service';
import {LoadingService} from '../shared/services/loading.service';
import {TrackingService} from '../services/tracking.service';
import {UrlBuilderService} from '../services/url-builder.service';
import {WebsiteBrand} from '../models/website-brand.model';
import {TranslateModule} from '@ngx-translate/core';
import {AsyncPipe, NgClass, NgIf, NgStyle} from '@angular/common';

@Component({
    selector: "newsletter",
    templateUrl: "./newsletter.component.html",
    styleUrls: ["./newsletter.component.scss"],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NgStyle,
        NgClass,
        AsyncPipe,
        TranslateModule,
    ],
})
export class NewsletterComponent implements OnInit {

  @Input()
  mode: "popup" | "home-page" = null;

  newsletterUrl: string;
  @Input()
  content: NewsletterFormContent;

  @Output()
  emailAdded = new EventEmitter();

  form: FormGroup;

  brand: WebsiteBrand

  newsletter$: Observable<NewsletterFormContent>;
  constructor(
    private fb: FormBuilder,
    private newsletter: NewsletterService,
    private loading: LoadingService,
    private messages: MessagesService,
    private store: Store<AppState>,
    private tracking: TrackingService,
    private ub: UrlBuilderService
  ) {
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      checkbox: [false, [Validators.requiredTrue]]
    });
    this.store.pipe(select(selectTenantInfo))
      .pipe(
        map(tenant => (this.brand = tenant?.brandTheme))
      )
      .subscribe();
  }
  ngOnInit() {
    this.newsletterUrl = this.ub.buildImageUrl("/images/newsletter/plane.png");

    if (this.content) {
      this.newsletter$ = of(this.content);
    } else {
      this.newsletter$ = this.store.pipe(
        select(selectNewsletterContent),
        map((newsletterContent) =>
          newsletterContent ? newsletterContent : <any>{}
        )
      );
    }
  }

  saveEmail() {

    if (!this.form.valid) {
      this.messages.i18nError("newsLetter.errorMessage");
      return;
    }

    const email = this.form.value.email;

    const addToNewsletter$ = this.newsletter.addToNewsletter(email);

    this.tracking.reportStudentLead();

    this.loading.showLoaderUntilCompleted(addToNewsletter$).subscribe(
      () => {
        this.messages.i18nInfo("newsLetter.thankYou");
        this.emailAdded.emit();
      },
      (err) => {
        console.log("Error subscribing to newsletter", err);
        this.messages.i18nError("newsLetter.subscriptionError");
      }
    );
  }

  toggle(checkbox: HTMLInputElement) {
    checkbox.checked = !checkbox.checked;
  }
}
